
import { supabase } from "@/integrations/supabase/client";

// UUID validation regex
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function isValidUUID(id: string): boolean {
  return UUID_REGEX.test(id);
}

export const updateMetaTags = async (positId: string) => {
  try {
    // Validate that positId is a proper UUID
    if (!isValidUUID(positId)) {
      return;
    }

    const { data: posit } = await supabase
      .from("posits")
      .select("title")
      .eq('id', positId)
      .single();

    if (!posit) return;

    // Update title tag
    const title = `${posit.title} - Your Digital You for Expertise Sharing`;
    document.title = title;
    
    // Update OpenGraph meta tags
    const metaTags = {
      'og:title': title,
      'og:description': "Access this personalized Digital You for insights, decision logic, and premium content—built to answer queries authentically and scale your knowledge.",
    };

    // Update each meta tag
    Object.entries(metaTags).forEach(([property, content]) => {
      const metaTag = document.querySelector(`meta[property="${property}"]`);
      if (metaTag) {
        metaTag.setAttribute('content', content);
      }
    });
  } catch (error) {
  }
};
